import { LoadingButton } from "@mui/lab";
import { Badge } from "@mui/material";
import { DashboardReportType } from "../../types/reports";

const getDashboardLabel = (dashboardReportType?: DashboardReportType): string => {
  switch (dashboardReportType) {
    case DashboardReportType.OutstandingChecks:
      return "Outstanding Checks";
    case DashboardReportType.PoliciesNotIssued:
      return "Policies Not Issued";
    case DashboardReportType.EscrowOverdue:
      return "Escrow Overdue";
    case DashboardReportType.NonZeroLedgerBalances:
      return "Non Zero Ledger Balances";
    case DashboardReportType.PoliciesToSend:
      return "Policies To Send";
    case DashboardReportType.PolicyIssues:
      return "Policies With Issues";
    case DashboardReportType.Deposits:
      return "Deposits";
    case DashboardReportType.ExcessRecordingFunds:
      return "Excess Recording Funds";
    default:
      return "Unknown Report Type";
  }
};

const DashboardBadge = ({
  badgeContent,
  href,
  disabled,
  color,
  hoverColor,
  hoverBackgroundColor,
  loading,
  dashboardReportType,
  labelOverride
}: {
  badgeContent: string | undefined;
  href: string;
  disabled: boolean;
  color: string;
  hoverColor: string;
  hoverBackgroundColor: string;
  loading?: boolean;
  dashboardReportType?: DashboardReportType;
  labelOverride?: string;
}) => {
  const label = labelOverride || getDashboardLabel(dashboardReportType);

  return (
    <Badge
      badgeContent={loading ? undefined : badgeContent}
      color={badgeContent === "0" ? undefined : "error"}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      sx={{
        "& .MuiBadge-badge": {
          backgroundColor: badgeContent === "0" ? "#c1c4c8" : undefined,
          color: badgeContent === "0" ? "white" : undefined
        }
      }}
    >
      <a href={href} target="_blank">
        <LoadingButton
          size="small"
          variant="outlined"
          disabled={disabled}
          loading={loading}
          loadingPosition="end"
          sx={{
            color,
            borderColor: color,
            userSelect: "none",
            paddingRight: 4,
            paddingLeft: 4,
            "&:hover": {
              backgroundColor: hoverBackgroundColor,
              color: hoverColor,
              borderColor: color
            }
          }}
        >
          {label}
        </LoadingButton>
      </a>
    </Badge>
  );
};
export default DashboardBadge;
